<agm-map [zoom]="mapZoom" [latitude]="latitude" [longitude]="longitude" (mapReady)="mapReadyHandler($event)">
  <agm-marker *ngFor="let device of deviceList" [latitude]="device.latitude" [longitude]="device.longitude"
    [iconUrl]="device.icon" (markerClick)="onMarkerClicked(device)">
    <agm-info-window>
      <div id="infoWindow">
        <ng-container i18n="@@useradd_devicesmap_serial">Seriale:</ng-container>{{ device.serial }}
        <br /><br />
        <ng-container i18n="@@useradd_devicesmap_activate">Abilitato: </ng-container>
        <mat-checkbox style="margin-bottom: 5px" (change)=addSelectedDevice(device) [checked]=device.selected
          [disabled]="groupSelected || !canUserEdit">
        </mat-checkbox>
        <br /><br />
        <!-- <fa-icon icon="edit" id="editButton" class="float-right padding-5 icon-clickable"
          (click)="modifyPermissions(device)" *ngIf="!groupSelected"></fa-icon> -->
        <ng-container *ngIf="device.shortPermissions != '-'"> {{ device.shortPermissions }} </ng-container>
      </div>
    </agm-info-window>
  </agm-marker>
</agm-map>
<app-loading-screen #devicesmaploader></app-loading-screen>
